<template>
    <div>
        <Header title="比赛信息" memo="管理比赛信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="primary" icon="plus" @click="showAddForm" :style="{ marginRight: '8px' }">
                    添加
                </a-button>

                <a-button type="danger" icon="delete" @click="execDelete" :style="{ marginRight: '8px' }" :disabled="selRows.length === 0">
                    删除
                </a-button>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <!-- <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item> -->
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table
            :style="{ marginTop: '16px' }"
            :row-key="record => record.id"
            :data-source="datas"
            :loading="loading"
            expandRowByClick
            :row-selection="{ type: 'checkbox', onChange: onSelectChange }"
            bordered
            :pagination="false"
        >
            <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
                参赛设备：
                <template v-if="record.state === 'Wait'">
                    <a-button v-for="ud in record.uds" :key="ud.did" @click="execDeleteDevice(record, ud)" :style="{ marginRight: '5px', marginBottom: '5px' }">
                        [{{ ud.sno }}] {{ ud.dname }} / {{ ud.name }}
                        <a-icon type="delete" :style="{ color: 'hotpink' }" />
                    </a-button>
                    <a-popover placement="top" trigger="click">
                        <template slot="content">
                            <a-form-model layout="inline">
                                <a-form-model-item>
                                    <a-select show-search v-model="bindDevice" :filter-option="false" :not-found-content="null" @search="doLoadDevice" :style="{ width: '200px' }">
                                        <a-select-option v-for="item in devices" :key="item.id" :value="item.id" :label="item.name">[{{ item.sno }}] {{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-model-item>
                                <a-form-model-item>
                                    <a-button icon="retweet" @click="doLoadDevice"></a-button>
                                </a-form-model-item>
                                <a-form-model-item>
                                    <a-button icon="link" @click="doAddDevice(record.id)">
                                        添加到比赛
                                    </a-button>
                                </a-form-model-item>
                            </a-form-model>
                        </template>
                        <template slot="title">
                            <span>选择设备添加到比赛</span>
                        </template>
                        <a-button :style="{ background: '#fff', borderStyle: 'dashed' }">
                            <a-icon type="plus" />
                            添加设备
                        </a-button>
                    </a-popover>
                </template>
                <template v-else>
                    <a-button v-for="ud in record.uds" :key="ud.did" :style="{ marginRight: '5px', marginBottom: '5px' }">[{{ ud.sno }}] {{ ud.dname }} / {{ ud.name }}</a-button>
                </template>
            </div>
            <a-table-column key="name" ellipsis>
                <span slot="title">比赛名称</span>
                <template slot-scope="text, record">
                    <a-tag color="#f50" v-if="record.state == 'Wait'">
                        未开始
                    </a-tag>
                    <a-tag color="#87d068" v-if="record.state == 'Start'">
                        已开始
                    </a-tag>
                    <a-tag color="#108ee9" v-if="record.state == 'Finish'">
                        已结束
                    </a-tag>
                    <span>{{ record.type | raceType }} / {{ (record.type + '_' + record.level) | raceLevel }} / {{ record.name }}</span>
                </template>
            </a-table-column>
            <a-table-column key="start" ellipsis width="360px">
                <span slot="title">比赛时间</span>
                <template slot-scope="text, record">
                    <span v-if="record.state != 'Wait'">{{ record.start }} 至 {{ record.end || '尚未结束' }}</span>
                    <span v-else>尚未开始</span>
                </template>
            </a-table-column>
            <a-table-column key="time" ellipsis width="180px">
                <span slot="title">开始时间</span>
                <template slot-scope="text, record">
                    <template v-if="record.time">
                        <span>{{ record.time }}</span>
                    </template>
                </template>
            </a-table-column>

            <a-table-column key="uds" ellipsis width="100px">
                <span slot="title">参与人数</span>
                <template slot-scope="text, record">
                    <span>{{ record.uds.length }}</span>
                </template>
            </a-table-column>
            <a-table-column key="state" ellipsis width="150px">
                <span slot="title">比赛状态</span>
                <template slot-scope="text, record">
                    <a-button icon="ordered-list" @click="showRstDlg(record)" v-if="record.state === 'Finish'">
                        查看成绩
                    </a-button>
                    <a-button type="danger" icon="play-circle" v-if="record.state === 'Wait'" @click="showStartDlg(record)">
                        开始比赛
                    </a-button>
                    <a-button type="primary" icon="check-circle" v-if="record.state === 'Start'" @click="execFinishRace(record)">
                        完成比赛
                    </a-button>
                </template>
            </a-table-column>
            <a-table-column key="action" fixed width="200px">
                <span slot="title">操作</span>
                <template slot-scope="text, record">
                    <a-button type="link" icon="edit" @click="showEditForm(record)">
                        编辑
                    </a-button>
                    <a-popconfirm :title="'是否删除比赛[' + record.name + ']，删除后无法恢复'" ok-type="danger" ok-text="确认删除" cancel-text="取消" @confirm="doDelete(record.id)">
                        <a-button type="link" icon="delete">
                            删除
                        </a-button>
                    </a-popconfirm>
                </template>
            </a-table-column>
        </a-table>

        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <FormComp title="编辑比赛信息" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></FormComp>
        <StartComp title="开始比赛" :item="now" :show.sync="startDlg" v-if="startDlg" @doLoad="doLoad"></StartComp>
        <RstComp title="比赛成绩" :item="now" :show.sync="rstDlg" v-if="rstDlg"></RstComp>
    </div>
</template>

<script>
import FormComp from './FormComp'
import StartComp from './StartComp'
import RstComp from './RstComp'
export default {
    name: 'AteUnitRace',
    components: {
        FormComp,
        StartComp,
        RstComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        }
    },
    data() {
        return {
            devices: [],
            bindDevice: '',
            query: {
                page: 1,
                size: 10,
                time: 0,
                unit: ''
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            form: false,
            now: {},
            startDlg: false,
            rstDlg: false
        }
    },
    filters: {
        raceType: value => {
            switch (value) {
                case 'R01':
                    return '注意力猜拳'
                case 'R02':
                    return '舒尔特方格'
                case 'R03':
                    return '虚实线'
                case 'R04':
                    return '中心悬点'
            }
        },
        raceLevel: value => {
            switch (value) {
                case 'R01_Easy':
                    return '简单（限时 2 秒）'
                case 'R01_Normal':
                    return '普通（限时 1.5 秒）'
                case 'R01_Hard':
                    return '困难（限时 1 秒）'
                case 'R02_Easy':
                    return '简单（3*3 方格）'
                case 'R02_Normal':
                    return '普通（4*4 方格）'
                case 'R02_Hard':
                    return '困难（5*5 方格）'
                case 'R03_Easy':
                    return '简单（1 行 2 图）'
                case 'R03_Normal':
                    return '标准（2 行 4 图）'
                case 'R03_Hard':
                    return '困难（2 行 6 图）'
                case 'R04_Easy':
                    return '简单（4 行 6 列）'
                case 'R04_Normal':
                    return '标准（5 行 8 列）'
                case 'R04_Hard':
                    return '困难（6 行 10 列）'
            }
        },
        raceState: value => {
            switch (value) {
                case 'Wait':
                    return '未开始'
                case 'Start':
                    return '已开始'
                case 'Finish':
                    return '已结束'
            }
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '比赛信息'])
        this.doLoadDevice()
        this.doLoad()
    },
    methods: {
        doLoadDevice(name) {
            this.$http
                .get('/cts/ate/device/mgr/query', {
                    params: {
                        size: 40,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.devices = result.datas
                })
        },

        doLoad() {
            this.$http
                .get('/cts/ate/race/mgr/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        doDelete(ids) {
            this.$http
                .post('/cts/ate/race/mgr/delete', {
                    ids: typeof ids === 'string' ? ids : ids.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('删除成功')
                        this.doLoad()
                    }
                })
        },
        doAddDevice(rid) {
            if (!this.bindDevice) {
                this.$message.error('请选择要添加的设备')
                return
            }
            this.$http
                .post('/cts/ate/race/mgr/device/add', {
                    id: rid,
                    did: this.bindDevice
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('添加成功')
                        this.bindDevice = ''
                        this.doLoad()
                    }
                })
        },
        doDeleteDevice(rid, did) {
            this.$http
                .post('/cts/ate/race/mgr/device/delete', {
                    id: rid,
                    did: did
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('删除成功')
                        this.doLoad()
                    }
                })
        },
        doFinishRace(rid) {
            this.$http
                .post('/cts/ate/race/mgr/finish', {
                    id: rid
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('操作成功')
                        this.doLoad()
                    }
                })
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                unit: ''
            }
            this.doLoad()
        },
        showAddForm() {
            this.now = {}
            this.form = true
        },
        showEditForm(item) {
            this.now = item
            this.form = true
        },
        showStartDlg(item) {
            this.now = item
            this.startDlg = true
        },
        showRstDlg(item) {
            this.now = item
            this.rstDlg = true
        },
        execDelete() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.name)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要删除的比赛信息')
                return
            }
            this.$confirm({
                title: '是否删除以下比赛信息？删除后无法恢复。',
                content: '名称：[' + names.join() + ']',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doDelete(ids)
                }
            })
        },
        execDeleteDevice(item, ud) {
            this.$confirm({
                title: '是否删除此设备',
                content: '设备：[' + ud.sno + ']' + ' ' + ud.dname,
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doDeleteDevice(item.id, ud.did)
                }
            })
        },
        execFinishRace(item) {
            this.$confirm({
                title: '是否完成比赛',
                content: '比赛：[' + item.name + ']',
                okText: '提交完成',
                okType: 'primary',
                cancelText: '取消',
                onOk: () => {
                    this.doFinishRace(item.id)
                }
            })
        }
    }
}
</script>
